import { ClerkProvider } from "@clerk/clerk-react";
import type { ReactNode } from "react";
import { ClerkAuthBridge } from "./ClerkAuthBridge";
import { clerkAppearance } from "./clerkAppearance";

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY?.trim() ?? "";

export function AppClerkProvider({ children }: { children: ReactNode }) {
  // The isolated animation study has no auth hooks or private project data.
  if (window.location.pathname.replace(/\/$/, '') === '/envelope-demo') return <>{children}</>;
  if (!publishableKey) {
    return (
      <div
        style={{
          padding: "2rem",
          fontFamily: "system-ui, sans-serif",
          maxWidth: 40 + "rem",
        }}
      >
        <h1>Clerk is not configured</h1>
        <p>
          Set <code>VITE_CLERK_PUBLISHABLE_KEY</code> in the product env (local{" "}
          <code>.env</code> / Cloudflare Pages) and{" "}
          <code>CLERK_SECRET_KEY</code> on the API (Railway).
        </p>
      </div>
    );
  }

  return (
    <ClerkProvider
      publishableKey={publishableKey}
      afterSignOutUrl="/"
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      appearance={clerkAppearance}
    >
      <ClerkAuthBridge>{children}</ClerkAuthBridge>
    </ClerkProvider>
  );
}
